document.addEventListener("DOMContentLoaded", () => {
  const carts = document.querySelectorAll("#main-cart-footer");

  if (!carts) {
    return;
  }

  addControlButtons();


  function addControlButtons() {
    carts.forEach((cart) => {
      const cartFooter = cart.querySelector(".cart__footer");
      if (!cartFooter) {
        return;
      }


      const providerId = "66c34a8e4216331499a74a75";

      cart.style["overflow-y"] = "hidden";
      const defaultLanguage = "en";
      const language = window?.Shopify?.locale || defaultLanguage;
      let translations = {};

      if (language !== defaultLanguage) {
        translations = {
          shipping: "Оберіть спосіб доставки",
          chooseDeliveryMethod: "Оберіть спосіб доставки",
          options: {
            warehouse: "Доставка Новою Поштою",
            courierDelivery: "Кур'єрська доставка",
            internationalDelivery: "Міжнародна доставка",
          },
          inputPlaceholders: {
            name: "Ім'я та прізвище",
            phone: "Номер телефону",
            settlement: "Оберіть населений пункт",
            warehouse: "Оберіть відділення або поштомат",
          },
        };
      } else {
        // en by default
        translations = {
          shipping: "Choose a delivery method",
          chooseDeliveryMethod: "Choose a delivery method",
          options: {
            warehouse: "NovaPoshta",
            courierDelivery: "Courier delivery",
            internationalDelivery: "International delivery",
          },
          inputPlaceholders: {
            name: "First and Last names",
            phone: "Phone number",
            settlement: "Select a settlement",
            warehouse: "Select branch / post office",
          },
        };
      }

      const cartSubmitButton = cartFooter.querySelector(".cart__ctas");

      const cartControls = `
      <div class="cart-controls active">
        <div class="cart-controls__divider"></div>
        <div class="cart-controls__buttons">
          <button class="cart-controls__button control-button" id="delivery" type="button">
            <svg
              class="control-button__icon"
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="0 0 491.1 491.1"
              xml:space="preserve">
              <path transform="translate(0 -540.36)" d="M401.5,863.31c-12,0-23.4,4.7-32,13.2c-8.6,8.6-13.4,19.8-13.4,31.8s4.7,23.2,13.4,31.8 c8.7,8.5,20,13.2,32,13.2c24.6,0,44.6-20.2,44.6-45S426.1,863.31,401.5,863.31z M401.5,933.31c-13.8,0-25.4-11.4-25.4-25 s11.6-25,25.4-25c13.6,0,24.6,11.2,24.6,25S415.1,933.31,401.5,933.31z M413.1,713.41c-1.8-1.7-4.2-2.6-6.7-2.6h-51.3 c-5.5,0-10,4.5-10,10v82c0,5.5,4.5,10,10,10h81.4c5.5,0,10-4.5,10-10v-54.9c0-2.8-1.2-5.5-3.3-7.4L413.1,713.41z M426.5,792.81 h-61.4v-62.1h37.4l24,21.6V792.81z M157.3,863.31c-12,0-23.4,4.7-32,13.2c-8.6,8.6-13.4,19.8-13.4,31.8s4.7,23.2,13.4,31.8 c8.7,8.5,20,13.2,32,13.2c24.6,0,44.6-20.2,44.6-45S181.9,863.31,157.3,863.31z M157.3,933.31c-13.8,0-25.4-11.4-25.4-25 s11.6-25,25.4-25c13.6,0,24.6,11.2,24.6,25S170.9,933.31,157.3,933.31z M90.6,875.61H70.5v-26.6c0-5.5-4.5-10-10-10s-10,4.5-10,10 v36.6c0,5.5,4.5,10,10,10h30.1c5.5,0,10-4.5,10-10S96.1,875.61,90.6,875.61z M141.3,821.11c0-5.5-4.5-10-10-10H10 c-5.5,0-10,4.5-10,10s4.5,10,10,10h121.3C136.8,831.11,141.3,826.71,141.3,821.11z M30.3,785.01l121.3,0.7c5.5,0,10-4.4,10.1-9.9 c0.1-5.6-4.4-10.1-9.9-10.1l-121.3-0.7c-0.1,0-0.1,0-0.1,0c-5.5,0-10,4.4-10,9.9C20.3,780.51,24.8,785.01,30.3,785.01z M50.7,739.61 H172c5.5,0,10-4.5,10-10s-4.5-10-10-10H50.7c-5.5,0-10,4.5-10,10S45.2,739.61,50.7,739.61z M487.4,726.11L487.4,726.11l-71.6-59.3 c-1.8-1.5-4-2.3-6.4-2.3h-84.2v-36c0-5.5-4.5-10-10-10H60.5c-5.5,0-10,4.5-10,10v73.2c0,5.5,4.5,10,10,10s10-4.5,10-10v-63.2h234.8 v237.1h-82c-5.5,0-10,4.5-10,10s4.5,10,10,10h122.1c5.5,0,10-4.5,10-10s-4.5-10-10-10h-20.1v-191.1h80.6l65.2,54l-0.7,136.9H460 c-5.5,0-10,4.5-10,10s4.5,10,10,10h20.3c5.5,0,10-4.4,10-9.9l0.8-151.6C491,730.91,489.7,728.01,487.4,726.11z" />
            </svg>
            <span class="control-button__button-text">${translations.shipping}</span>
          </button>
        </div>
      </div>
    `;

      const deliveryOverlay = `
        <div class="cart-controls__overlay controls-overlay">
          <div class="controls-overlay__divider"></div>
          <button class="controls-overlay__close-button" type="button">
            <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_422_2824)">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M1.95098 0.334735C1.50466 -0.111578 0.781048 -0.111578 0.334735 0.334735C-0.111578 0.781048 -0.111578 1.50466 0.334735 1.95098L6.38376 8L0.334735 14.049C-0.111578 14.4953 -0.111578 15.219 0.334735 15.6653C0.781048 16.1115 1.50466 16.1115 1.95098 15.6653L8 9.61624L14.049 15.6653C14.4953 16.1115 15.219 16.1115 15.6653 15.6653C16.1115 15.219 16.1115 14.4953 15.6653 14.049L9.61624 8L15.6653 1.95098C16.1115 1.50466 16.1115 0.781048 15.6653 0.334735C15.219 -0.111578 14.4953 -0.111578 14.049 0.334735L8 6.38376L1.95098 0.334735Z" />
              </g>
              <defs>
                <clipPath id="clip0_422_2824">
                  <rect
                    width="16"
                    height="16"
                    fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
  
          <div class="controls-overlay__form overlay-form">
            <h3 class="controls-overlay__title">${translations.chooseDeliveryMethod}</h3>
            <ul class="overlay-form__delivery-type-block">
              <li>
                <label class="overlay-form__delivery-type">
                  <input
                    class="overlay-form__radio-input"
                    type="radio"
                    name="delivery-type"
                    id="delivery-warehouse"
                    value="warehouse"
                    checked>
                  <span class="overlay-form__radio-checkmark"></span>
                  <span>${translations.options.warehouse}</span>
                </label>
              </li>
              <li>
                <label class="overlay-form__delivery-type">
                  <input
                    class="overlay-form__radio-input"
                    type="radio"
                    name="delivery-type"
                    id="delivery-courier-delivery"
                    value="courier-delivery">
                  <span class="overlay-form__radio-checkmark"></span>
                  <span>${translations.options.courierDelivery}</span>
                </label>
              </li>
              <li>
                <label class="overlay-form__delivery-type">
                  <input
                    class="overlay-form__radio-input"
                    type="radio"
                    name="delivery-type"
                    id="delivery-international-delivery"
                    value="international-delivery">
                  <span class="overlay-form__radio-checkmark"></span>
                  <span>${translations.options.internationalDelivery}</span>
                </label>
              </li>
            </ul>
            <div class="overlay-form__address-block">
            <input
              class="overlay-form__input"
              type="text"
              name="name"
              id="name"
              placeholder="${translations.inputPlaceholders.name}"
              required>
            <input
              class="overlay-form__input"
              type="text"
              name="phone"
              id="phone"
              placeholder="${translations.inputPlaceholders.phone}"
              required>
              <div class="overlay-form__input-wrapper">
                <input
                  class="overlay-form__input"
                  type="text"
                  name="settlement"
                  id="settlement"
                  placeholder="${translations.inputPlaceholders.settlement}"
                  required>
                <ul class="overlay-form__suggestions" id="suggestions-settlement"></ul>
              </div>
              <div class="overlay-form__input-wrapper">
                <input
                  class="overlay-form__input"
                  type="text"
                  name="warehouse"
                  id="warehouse"
                  placeholder="${translations.inputPlaceholders.warehouse}"
                  required>
                <ul class="overlay-form__suggestions" id="suggestions-warehouse"></ul>
              </div>
            </div>
          </div>
        </div>
      `;

      cartSubmitButton.insertAdjacentHTML("beforebegin", cartControls);
      cartSubmitButton.insertAdjacentHTML("beforebegin", deliveryOverlay);

      const deliveryTypeRadios = cart.querySelectorAll(
        ".overlay-form__radio-input"
      );
      const inputs = cart.querySelectorAll(".overlay-form__input");

      // Disable inputs when international delivery is selected
      deliveryTypeRadios.forEach((radio) => {
        radio.addEventListener("change", (event) => {
          const deliveryType = event.target.value;

          if (deliveryType === "international-delivery" || deliveryType === "courier-delivery") {
            inputs.forEach((input) => {
              if (input.name === "name" || input.name === "phone") return;
              input.disabled = true;
            });
          } else {
            inputs.forEach((input) => {
              input.disabled = false;
            });
          }
        });
      });

      const cartComtrolButtonsBlock = cart.querySelector(".cart-controls");
      const controlButtons = cart.querySelector(".cart-controls__buttons");
      const overlay = cart.querySelector(".cart-controls__overlay");
      const overlayCloseBtn = cart.querySelector(
        ".controls-overlay__close-button"
      );
      const suggestionsLists = cart.querySelectorAll(
        ".overlay-form__suggestions"
      );
      const submitButton = cartFooter.querySelector('button[type="submit"]');
      const originalSubmitButtonText = submitButton.innerHTML;
      let deliveryCity = "";

      overlayCloseBtn.addEventListener("click", toggleOverlay);

      // Open overlay on button click
      controlButtons.addEventListener("click", (event) => {
        if (event.target.closest(".control-button")) {
          toggleOverlay();
        }
      });

      let currentInputId = null;
      inputs.forEach((input) => {
        // Fetch data on input change
        input.addEventListener("input", (event) => {
          const value = event.target.value.trim();
          const inputId = event.target.id;

          if (value) {
            if (inputId === "settlement") {
              fetch(
                "https://api.3lines.tech/api/v1/delivery/novaPost/searchSettlements",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    providerId: "667a6cfc40827a30f6648f9d",
                    cityName: value,
                  }),
                }
              )
                .then((response) => response.json())
                .then((data) => {
                  // Display suggestions (elastic search)
                  displaySuggestions(inputId, data.settlements);
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
            } else if (inputId === "warehouse") {
              fetch(
                "https://api.3lines.tech/api/v1/delivery/novaPost/getWarehouses",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    findByString: value,
                    providerId: "667a6cfc40827a30f6648f9d",
                    cityRef: deliveryCity,
                  }),
                }
              )
                .then((response) => response.json())
                .then((data) => {
                  // Display suggestions (elastic search)
                  displaySuggestions(inputId, data.warehouses);
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
            }
          } else {
            // Clear suggestions (elastic search) if input is empty
            if (inputId === "name" || inputId === "phone") {
              return;
            }

            clearSuggestions(inputId);
          }
        });
      });

      // Close suggestions on click outside
      document.addEventListener("click", (event) => {
        const isInput = event.target.classList.contains("overlay-form__input");
        const isSuggestion = event.target.classList.contains(
          "overlay-form__suggestions"
        );
        const isCurrentInput = event.target.id === currentInputId;

        if ((!isInput && !isSuggestion) || !isCurrentInput) {
          suggestionsLists.forEach((list) => {
            list.style.display = "none";
          });
        }
      });

      let isHovered = false;
      let isOriginalText = true;

      // Change submit button text on hover
      submitButton.addEventListener("mouseover", () => {
        if (!isHovered) {
          changeSubmitButtonText(
            `<span>${translations.chooseDeliveryMethod}</span>`
          );
          isHovered = true;
          isOriginalText = false;
        }
      });

      submitButton.addEventListener("mouseout", () => {
        if (!isOriginalText) {
          changeSubmitButtonText(originalSubmitButtonText);
          isHovered = false;
          isOriginalText = true;
        }
      });

      submitButton.addEventListener("click", async (event) => {
        event.preventDefault();
        // Get delivery info
        const { deliveryType, name, phone, settlement, warehouse } =
          getDeliveryInfo();
        const isWarehouse = deliveryType === "warehouse";
        const isCourier = deliveryType === "courier-delivery";

        // Open overlay if name or phone is not selected
        if (!name || !phone) {
          if (!overlay.classList.contains("active")) {
            toggleOverlay();
          }
          return;
        }

        // Open overlay if warehouse delivery is selected but settlement or warehouse is not selected
        if (isWarehouse) {
          if (!settlement || !warehouse) {
            if (!overlay.classList.contains("active")) {
              toggleOverlay();
            }
            return;
          }
        }

        // Cart attributes
        const names = name?.split(" ");
        const firstName = names?.shift();
        const lastName = names?.join(" ");
        const attributes = isWarehouse
          ? {
              _provider: "Нова пошта",
              _delivery_method: "Відділення / Поштомат",
              _delivery_first_name: firstName,
              _delivery_last_name: lastName,
              _delivery_phone: phone,
              _delivery_city: settlement,
              _delivery_warehouse: warehouse,
              _delivery_warehouse_zip: "11111",
            }
          : {
              _provider: "",
              _delivery_method: isCourier ? "Кур'єрська доставка" : "Міжнародна доставка",
              _delivery_first_name: firstName,
              _delivery_last_name: lastName,
              _delivery_phone: phone,
              _delivery_city: "",
              _delivery_warehouse: "",
              _delivery_warehouse_zip: "",
            };

        try {
          // Update cart attributes
          await fetch("/cart/update.js", {
            method: "POST",
            mode: "cors",
            credentials: "include",
            cache: "no-cache",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              attributes,
            }),
          });

          const geoResponse = await fetch("https://ipinfo.io/json");
          const geo = await geoResponse.json();
          const countryCode = geo?.country;

          // Add delivery info to cart note
          const address = isWarehouse
            ? {
                countryCode: "UA",
                country: "Ukraine",
                address1: warehouse,
                zip: "11111",
                city: settlement,
                first_name: firstName,
                last_name: lastName,
                phone: phone,
              }
            : isCourier
            ? {
                countryCode: "UA",
                country: "Ukraine",
                address1: "",
                zip: "",
                city: "",
                first_name: firstName,
                last_name: lastName,
                phone: phone,
            } 
            : {
                countryCode: countryCode,
                country: countries[countryCode],
                address1: "",
                zip: "",
                city: "",
                first_name: firstName,
                last_name: lastName,
                phone: phone,
              };

          const response = await fetch("/cart.json");
          const data = await response.json();

          const pairs = [],
            path = data.items
              .map((item) => `${item.variant_id}:${item.quantity}`)
              .join(",");
          for (const key in attributes) {
            if (!attributes[key]) continue;
            const pair = `attributes[${key}]=${attributes[key]}`;
            pairs.push(pair);
          }
          for (const key in address) {
            const pair = `checkout[shipping_address][${key}]=${address[key]}`;
            pairs.push(pair);
          }

          // Redirect to checkout
          let params, url;
          const isDefaultLanguage = defaultLanguage === language;
          data.note && data.note != null
            ? ((params = pairs.join("&") + `&note=${data.note}`),
              (url = isDefaultLanguage
                ? `/cart/${path}?${params}`
                : `/${language}/cart/${path}?${params}`))
            : ((params = pairs.join("&")),
              (url = isDefaultLanguage
                ? `/cart/${path}?${params}`
                : `/${language}/cart/${path}?${params}`)),
            (window.location.href = url);
        } catch (error) {
          console.error("Error:", error);
        }
      });

      function getDeliveryInfo() {
        const deliveryType = cart.querySelector(
          'input[name="delivery-type"]:checked'
        ).value;
        const name = cart.querySelector("#name").value;
        const phone = cart.querySelector("#phone").value;
        const settlement = cart.querySelector("#settlement").value;
        const warehouse = cart.querySelector("#warehouse").value;

        return {
          deliveryType,
          name,
          phone,
          settlement,
          warehouse,
        };
      }

      // Change submit button text with animation
      function changeSubmitButtonText(text) {
        if (submitButton.innerHTML !== text) {
          const { deliveryType, name, phone, settlement, warehouse } =
            getDeliveryInfo();

          const animate = () => {
            submitButton.classList.add("change-text-animation");

            setTimeout(() => {
              submitButton.innerHTML = text;
            }, 125); // Animation duration (half of the CSS transition duration)

            setTimeout(() => {
              submitButton.classList.remove("change-text-animation");
            }, 250); // Animation duration (CSS transition duration)
          };

          if (!name || !phone) {
            animate();
            return;
          }

          if (deliveryType === "warehouse") {
            if (!settlement || !warehouse) {
              animate();
            }
          }
        }
      }

      function toggleOverlay() {
        overlay.classList.toggle("active");
        cartComtrolButtonsBlock.classList.toggle("active");
        if (overlay.classList.contains("active")) {
          submitButton.style.zIndex = "10";
        } else {
          setTimeout(() => {
            submitButton.style.zIndex = "6";
          }, 200);
        }
      }

      function displaySuggestions(inputId, data) {
        currentInputId = inputId;
        const suggestionsList = cart.querySelector(`#suggestions-${inputId}`);
        suggestionsList.innerHTML = "";
        const isSettlement = inputId === "settlement";
        data.forEach((item) => {
          const li = document.createElement("li");
          li.textContent = isSettlement ? item.Present : item.Description;

          li.addEventListener("click", () => {
            cart.querySelector(`#${inputId}`).value = isSettlement
              ? item.Present
              : item.Description;
            clearSuggestions(inputId);

            if (isSettlement) {
              deliveryCity = item.DeliveryCity;
            }
          });

          suggestionsList.appendChild(li);
        });
        suggestionsList.style.display = "block";
      }

      function clearSuggestions(inputId) {
        const suggestionsList = cart.querySelector(`#suggestions-${inputId}`);
        suggestionsList.innerHTML = "";
        suggestionsList.style.display = "none";
      }
    });
  }

  const countries = {
    AF: "Afghanistan",
    AX: "Aland Islands",
    AL: "Albania",
    DZ: "Algeria",
    AS: "American Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctica",
    AG: "Antigua And Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia And Herzegovina",
    BW: "Botswana",
    BV: "Bouvet Island",
    BR: "Brazil",
    IO: "British Indian Ocean Territory",
    BN: "Brunei Darussalam",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CV: "Cape Verde",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CX: "Christmas Island",
    CC: "Cocos (Keeling) Islands",
    CO: "Colombia",
    KM: "Comoros",
    CG: "Congo",
    CD: "Congo, Democratic Republic",
    CK: "Cook Islands",
    CR: "Costa Rica",
    CI: "Cote D'Ivoire",
    HR: "Croatia",
    CU: "Cuba",
    CY: "Cyprus",
    CZ: "Czech Republic",
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Ethiopia",
    FK: "Falkland Islands (Malvinas)",
    FO: "Faroe Islands",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GF: "French Guiana",
    PF: "French Polynesia",
    TF: "French Southern Territories",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Greece",
    GL: "Greenland",
    GD: "Grenada",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard Island & Mcdonald Islands",
    VA: "Holy See (Vatican City State)",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: "Iran, Islamic Republic Of",
    IQ: "Iraq",
    IE: "Ireland",
    IM: "Isle Of Man",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JE: "Jersey",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KR: "Korea",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Lao People's Democratic Republic",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libyan Arab Jamahiriya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macao",
    MK: "Macedonia",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    FM: "Micronesia, Federated States Of",
    MD: "Moldova",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MS: "Montserrat",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Netherlands",
    AN: "Netherlands Antilles",
    NC: "New Caledonia",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    MP: "Northern Mariana Islands",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: "Palestinian Territory, Occupied",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PN: "Pitcairn",
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    RE: "Reunion",
    RO: "Romania",
    RU: "Russian Federation",
    RW: "Rwanda",
    BL: "Saint Barthelemy",
    SH: "Saint Helena",
    KN: "Saint Kitts And Nevis",
    LC: "Saint Lucia",
    MF: "Saint Martin",
    PM: "Saint Pierre And Miquelon",
    VC: "Saint Vincent And Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome And Principe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    GS: "South Georgia And Sandwich Isl.",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard And Jan Mayen",
    SZ: "Swaziland",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syrian Arab Republic",
    TW: "Taiwan",
    TJ: "Tajikistan",
    TZ: "Tanzania",
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad And Tobago",
    TN: "Tunisia",
    TR: "Turkey",
    TM: "Turkmenistan",
    TC: "Turks And Caicos Islands",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    AE: "United Arab Emirates",
    GB: "United Kingdom",
    US: "United States",
    UM: "United States Outlying Islands",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Viet Nam",
    VG: "Virgin Islands, British",
    VI: "Virgin Islands, U.S.",
    WF: "Wallis And Futuna",
    EH: "Western Sahara",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe",
  };
});
